import { type FC, type ReactNode } from "react";

type Props = {
  icon: ReactNode;
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onEnter: () => void;
  type?: "email" | "text";
  inputMode?: "email" | "text";
  autoComplete?: string;
  disabled?: boolean;
  "aria-describedby"?: string | undefined;
  "aria-invalid"?: boolean;
};

const SweepstakesField: FC<Props> = ({
  icon,
  label,
  placeholder,
  value,
  onChange,
  onEnter,
  type = "text",
  inputMode,
  autoComplete,
  disabled,
  "aria-describedby": ariaDescribedBy,
  "aria-invalid": ariaInvalid,
}) => (
  <div className="group flex h-[72px] w-full items-center gap-6 rounded-[16px] bg-white px-4 has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-[#1f2022] has-[input:focus-visible]:ring-offset-2 md:px-5 xl:px-6 2xl:px-8">
    <span
      aria-hidden="true"
      className="shrink-0 text-[#1f2022] [&>svg]:[stroke-width:1.5]"
    >
      {icon}
    </span>
    <input
      aria-label={label}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid}
      type={type}
      inputMode={inputMode}
      autoComplete={autoComplete}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") onEnter();
      }}
      className="w-full bg-transparent font-ppMori text-[14px] leading-[20px] text-[#1f2022] placeholder:text-[#1f2022] focus:outline-none md:text-[16px] md:leading-[22px] 2xl:text-[18px] 2xl:leading-[26px]"
    />
  </div>
);

export default SweepstakesField;
